import { createFileRoute } from '@tanstack/react-router';
import React from 'react';

import TournamentJoinPage from '~/play/join/TournamentJoinPage';

export const Route = createFileRoute('/tournaments/$id/join')({
  component: TournamentJoinRoute,
});

function TournamentJoinRoute() {
  const { id } = Route.useParams();
  return <TournamentJoinPage id={id} />;
}
